<div
  class="w-full min-h-screen
         grid grid-cols-1 lg:grid-cols-2
         bg-[#fffcf9]
         overflow-x-hidden"
>

  <!-- ========================================================= -->
  <!-- DESKTOP IMAGE PANEL -->
  <!-- ========================================================= -->

  <section class="auth-hero hidden lg:block" aria-label="CircledPlus private marketplace">
    <img class="auth-hero-image" src="assets/img/Circled_Plus_Login.webp"
         alt="Luxury apartment in Bengaluru" width="720" height="1080" />
    <div class="auth-hero-shade" aria-hidden="true"></div>
    <div class="auth-hero-copy">
      <span class="auth-hero-label">Circled+ Private Marketplace</span>
      <p class="auth-hero-kicker">Private Member Access</p>
      <h1>Discover Bengaluru’s<br>finest homes.</h1>
      <p>Curated properties, private access and smarter decisions for discerning home buyers.</p>
    </div>
  </section>


  <!-- ========================================================= -->
  <!-- FORM PANEL -->
  <!-- ========================================================= -->

  <main
    class="w-full min-h-screen
           bg-[#fffcf9]"
  >

    <div
      class="otp-panel w-full min-h-screen
             flex flex-col
             items-center
             px-5 py-7
             sm:px-8 sm:py-10
             lg:px-12
             xl:px-16
             lg:justify-center"
    >

      <div
        class="w-full
               max-w-[500px]
               flex flex-col items-center"
      >

        <!-- ===================================================== -->
        <!-- LOGO -->
        <!-- ===================================================== -->

        <div
          class="flex items-center justify-center
                 mb-7"
        >

          <a routerLink="/" class="auth-logo-link" aria-label="CircledPlus home">
          <img
            src="/cir-home/images/circledplus-logo.svg"
            alt="CircledPlus"
            class="auth-logo"
          width="156" height="40" />
          </a>

        </div>


        <!-- ===================================================== -->
        <!-- HEADER -->
        <!-- ===================================================== -->

        <div class="otp-heading w-full text-center">

          <div class="inline-flex items-center gap-2 mb-4">
            <span class="w-1.5 h-1.5 rounded-full bg-[#8c52ff]"></span>
            <span class="text-[11px] font-bold uppercase tracking-[0.2em] text-[#7641cf]">Secure Verification</span>
            <span class="w-1.5 h-1.5 rounded-full bg-[#8c52ff]"></span>
          </div>

          <h2
            class="font-semibold leading-tight"
            style="font-family:'Georgia','Times New Roman',serif; font-size:clamp(1.875rem,2.5vw,2.25rem); color:#242126; letter-spacing:-1px;"
          >
            Verify your account
          </h2>


          <p
            class="mt-3
                   max-w-[500px]
                   mx-auto
                   text-[15px]
                   leading-6
                   text-[#706971]"
          >
            We’ve sent a 6 digit OTP to your registered
            {{userData?.isIndia ? 'phone' : 'email'}}
            {{sendOtpIdentifiers}}
          </p>

          <button
            type="button"
            (click)="changeIdentifier()"
            class="otp-change-identifier"
          >
            Change email / mobile number
          </button>

        </div>

        <!-- ===================================================== -->
        <!-- OTP FORM -->
        <!-- ===================================================== -->

        <form
          class="otp-form w-full mt-9"
          [formGroup]="otpVerificationForm"
          (ngSubmit)="otpVerificationForm.valid && verifyOtp()"
          autocomplete="one-time-code"
        >

          <!-- =================================================== -->
          <!-- OTP INPUTS -->
          <!-- =================================================== -->

          <div
            class="w-full
                   flex justify-center
                   gap-2.5
                   sm:gap-3
                   px-1"
          >

            <!-- OTP 1 -->

            <input
              #otp1
              id="otp-1"
              name="otp-1"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
              formControlName="otp1"
              (input)="onInput($event, 0)"
              (keydown)="onKeyDown($event, 0)"
              (paste)="onPaste($event)"
              aria-label="OTP digit 1"
              class="otp-box 
                w-11 h-14
                sm:w-12 sm:h-14
                md:w-14 md:h-16
                shrink-0
                rounded-2xl
                border border-[#e7e1dc]
                bg-white
                text-center
                text-[20px]
                sm:text-[22px]
                font-semibold
                text-[#8c52ff]
                outline-none
                caret-[#8c52ff]
                transition-all duration-200
                focus:border-[#8c52ff]
                focus:ring-4
                focus:ring-[#8c52ff]/10
                focus:bg-[#fdfbff]
              "
            />


            <!-- OTP 2 -->

            <input
              #otp2
              id="otp-2"
              name="otp-2"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              formControlName="otp2"
              (input)="onInput($event, 1)"
              (keydown)="onKeyDown($event, 1)"
              aria-label="OTP digit 2"
              class="otp-box 
                w-11 h-14
                sm:w-12 sm:h-14
                md:w-14 md:h-16
                shrink-0
                rounded-2xl
                border border-[#e7e1dc]
                bg-white
                text-center
                text-[20px]
                sm:text-[22px]
                font-semibold
                text-[#8c52ff]
                outline-none
                caret-[#8c52ff]
                transition-all duration-200
                focus:border-[#8c52ff]
                focus:ring-4
                focus:ring-[#8c52ff]/10
                focus:bg-[#fdfbff]
              "
            />


            <!-- OTP 3 -->

            <input
              #otp3
              id="otp-3"
              name="otp-3"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              formControlName="otp3"
              (input)="onInput($event, 2)"
              (keydown)="onKeyDown($event, 2)"
              aria-label="OTP digit 3"
              class="otp-box 
                w-11 h-14
                sm:w-12 sm:h-14
                md:w-14 md:h-16
                shrink-0
                rounded-2xl
                border border-[#e7e1dc]
                bg-white
                text-center
                text-[20px]
                sm:text-[22px]
                font-semibold
                text-[#8c52ff]
                outline-none
                caret-[#8c52ff]
                transition-all duration-200
                focus:border-[#8c52ff]
                focus:ring-4
                focus:ring-[#8c52ff]/10
                focus:bg-[#fdfbff]
              "
            />


            <!-- OTP 4 -->

            <input
              #otp4
              id="otp-4"
              name="otp-4"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              formControlName="otp4"
              (input)="onInput($event, 3)"
              (keydown)="onKeyDown($event, 3)"
              aria-label="OTP digit 4"
              class="otp-box 
                w-11 h-14
                sm:w-12 sm:h-14
                md:w-14 md:h-16
                shrink-0
                rounded-2xl
                border border-[#e7e1dc]
                bg-white
                text-center
                text-[20px]
                sm:text-[22px]
                font-semibold
                text-[#8c52ff]
                outline-none
                caret-[#8c52ff]
                transition-all duration-200
                focus:border-[#8c52ff]
                focus:ring-4
                focus:ring-[#8c52ff]/10
                focus:bg-[#fdfbff]
              "
            />


            <!-- OTP 5 -->

            <input
              #otp5
              id="otp-5"
              name="otp-5"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              formControlName="otp5"
              (input)="onInput($event, 4)"
              (keydown)="onKeyDown($event, 4)"
              aria-label="OTP digit 5"
              class="otp-box 
                w-11 h-14
                sm:w-12 sm:h-14
                md:w-14 md:h-16
                shrink-0
                rounded-2xl
                border border-[#e7e1dc]
                bg-white
                text-center
                text-[20px]
                sm:text-[22px]
                font-semibold
                text-[#8c52ff]
                outline-none
                caret-[#8c52ff]
                transition-all duration-200
                focus:border-[#8c52ff]
                focus:ring-4
                focus:ring-[#8c52ff]/10
                focus:bg-[#fdfbff]
              "
            />


            <!-- OTP 6 -->

            <input
              #otp6
              id="otp-6"
              name="otp-6"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              formControlName="otp6"
              (input)="onInput($event, 5)"
              (keydown)="onKeyDown($event, 5)"
              aria-label="OTP digit 6"
              class="otp-box 
                w-11 h-14
                sm:w-12 sm:h-14
                md:w-14 md:h-16
                shrink-0
                rounded-2xl
                border border-[#e7e1dc]
                bg-white
                text-center
                text-[20px]
                sm:text-[22px]
                font-semibold
                text-[#8c52ff]
                outline-none
                caret-[#8c52ff]
                transition-all duration-200
                focus:border-[#8c52ff]
                focus:ring-4
                focus:ring-[#8c52ff]/10
                focus:bg-[#fdfbff]
              "
            />

          </div>


          <!-- =================================================== -->
          <!-- SECURITY NOTE -->
          <!-- =================================================== -->

          <div
            class="mt-5
                   flex items-center
                   justify-center
                   gap-2
                   text-xs
                   text-[#706971]"
          >

            <svg
              class="w-4 h-4 text-[#8c52ff]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              aria-hidden="true"
            >
              <path
                d="M12 3l7 3v5c0 4.6-2.9 8.5-7 10-4.1-1.5-7-5.4-7-10V6l7-3Z"
              />
              <path
                d="m9 12 2 2 4-4"
              />
            </svg>

            Your verification is encrypted and secure.

          </div>


          <!-- =================================================== -->
          <!-- VERIFY BUTTON -->
          <!-- =================================================== -->

          <button
            type="submit"
            class="
              mt-7
              w-full h-14
              rounded-full
              bg-[#242126]
              text-white
              text-base
              font-semibold
              tracking-wide
              transition-all duration-200
              hover:bg-[#8c52ff]
              active:scale-[0.99]
              focus:outline-none
              focus:ring-4
              focus:ring-[#8c52ff]/15
            "
          >
            Verify OTP
          </button>

        </form>


        <!-- ===================================================== -->
        <!-- RESEND -->
        <!-- ===================================================== -->

        <div
          class="mt-7
                 flex items-center
                 justify-center
                 gap-1.5
                 text-sm"
        >

          <span class="text-[#706971]">
            Didn't receive the code?
          </span>

          <button
            type="button"
            class="
              font-semibold
              text-[#8c52ff]
              hover:underline
              disabled:opacity-40
              disabled:no-underline
            "
            [disabled]="!showResend"
            (click)="resendOtp()"
          >
            {{showResend ? 'Resend OTP' : 'Resend in ' + countdown}}
          </button>

        </div>


        <!-- ===================================================== -->
        <!-- FOOTER -->
        <!-- ===================================================== -->

        <div
          class="mt-10
                 w-full
                 pt-6
                 border-t border-[#e7e1dc]
                 text-center"
        >

          <p
            class="text-xs
                   leading-5
                   text-[#706971]"
          >
            By continuing, you agree to CircledPlus's
            Terms of Service and Privacy Policy.
          </p>

        </div>

      </div>

    </div>

  </main>

</div>
